namespace GeniuzPOS.ReportMasterData {
    export interface Report_1319Form {
    }

    export class Report_1319Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1319';
    }
}
